import { createContext } from "react";

export function createRouteBodyRetention() {
  const leases = new Set<symbol>();
  const listeners = new Set<() => void>();
  const emit = () => {
    for (const listener of listeners) {
      listener();
    }
  };
  return {
    canRelease: () => leases.size === 0,
    retain: () => {
      const lease = Symbol();
      leases.add(lease);
      emit();
      return () => {
        if (leases.delete(lease)) {
          emit();
        }
      };
    },
    subscribe: (listener: () => void) => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
  };
}

export const RouteBodyRetentionContext = createContext<ReturnType<
  typeof createRouteBodyRetention
> | null>(null);
